import React, {useEffect, useState} from "react";
import {Tabs, Card, message} from 'antd';
import {getHostAddress} from "../../Tool/UtileFun";
import cookie from "react-cookies"
import { List, Avatar } from 'antd';
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';


import { Player } from 'video-react';
//import "node_modules/video-react/dist/video-react.css";

export function ExperimentContent(){

    const { TabPane } = Tabs;

    useEffect(
        ()=>{
            console.log("experimentCiikie:"+cookie.load("experimentId"))
            loadExperiment()
            loadVideoList()
        },[]
    );

    const [experiment,setExperiment] = useState({})
    const [videoList,setVideoList] = useState([])

    const loadExperiment=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/findById",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:cookie.load("experimentId")}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setExperiment(data)
                console.log("data:")
                console.log(cookie.load(data))
            })
            .catch(error => message.error("error"+error));
    }

    const loadVideoList=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/resourcesAddress/findByExperimentId",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:cookie.load("experimentId")}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setVideoList(data)
            })
            .catch(error => message.error("error"+error));
    }



    const data = [
        {
            title: 'Ant Design Title 1',
        },
        {
            title: 'Ant Design Title 2',
        },
        {
            title: 'Ant Design Title 3',
        },
        {
            title: 'Ant Design Title 4',
        },
    ];

    const lists = (
        <List
            itemLayout="horizontal"
            dataSource={videoList}
            renderItem={item => (
                <List.Item>
                    <List.Item.Meta
                        title={<a href={item.resourcesAddress}  target="_blank">{item.resourcesName}</a>}
                        description={item.content}
                    />
                </List.Item>
            )}
        />
            )


    const props = {
        name: 'file',
        action: "http://"+getHostAddress()+"/resourcesAddress/upload",
        headers: {
            authorization: 'authorization-text',
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
                console.log("返回")
                console.log(info.file.response)
            }
            if (info.file.status === 'done' && info.file.response.state === 'success') {
                message.success(`${info.file.name} 文件上传成功`);
            } else if (info.file.status === 'error' && info.file.response.state === 'error') {
                message.error(`${info.file.name} 文件上传失败`);
            }
        },
    };

    const content = (
        <Card>
            <Tabs defaultActiveKey="1">
                <TabPane tab="实验概述" key="1">
                    <p>实验名称:&nbsp;{experiment.target}</p>
                    <p>{experiment.content}</p>
                </TabPane>
                <TabPane tab="目录" key="2">
                    {/*{<a href={"http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"}  target="_blank" >aaaa</a>}*/}
                    {lists}
                </TabPane>
                <TabPane tab="报告上传" key="3">
                    <Upload {...props}>
                        <Button icon={<UploadOutlined />}>Click to Upload</Button>
                    </Upload>
                </TabPane>
            </Tabs>
        </Card>
    )

    return(
        content
    )
}
